import { formatNumber } from "helpers/utils";
import { t } from "i18next";

import type { DataType } from "../../utils";
import { isCurrencyDataType } from "../../utils";
import type { LineChartData } from "../utils";
/**
 * Render data label at each Line Chart points
 * @param value Current line point value
 * @param context Chart js context
 * @param data Data for line-chart
 * @returns {string} Point label
 */
export const linePointsDataLabelsFormat = (value: number, context: any, data: LineChartData) => {
    const { dataIndex } = context;
    const { data: lineData } = context.dataset;
    const isEndpointValue = dataIndex === 0 || dataIndex === lineData.length - 1;
    const hasMoreThanTwoLines = data?.datasets?.length > 3;
    const isZero = value === 0;

    // Don't render label if for endpoint data points and if data value equals 0
    if (isEndpointValue || isZero || hasMoreThanTwoLines) return "";
    return `${formatNumber(value, { noDigit: true })}`;
};

/**
 * Format tooltip label for Line Chart
 * @param context Chart js context
 * @param dataType Chosen type of data (turnover / quantities / custom turnover columns)
 */
export const lineTooltipLabelFormat = (context: any, dataType: DataType) => {
    const datasetLabel = context.dataset.label || "";
    const value = context.raw;
    const formattedValue = isCurrencyDataType(dataType)
        ? formatNumber(value, { isCurrency: true })
        : `${value} ${t("Analytics.Copies")}`;

    if (datasetLabel === t("Analytics.SumOfMenus")) {
        return formattedValue;
    }

    return `${datasetLabel}: ${formattedValue}`;
};
